import { Component, inject } from '@angular/core';
import { ScreenService } from '@shared/services/screen';
import { BreadcrumbState } from './states/breadcrumb.state';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
})
export class BreadcrumbComponent {
  private readonly screenService = inject(ScreenService);
  private readonly breadcrumbState = inject(BreadcrumbState);

  readonly isMobile = this.screenService.isMobile;
  readonly breadcrumbs = this.breadcrumbState.breadcrumbs;
  readonly currentPage = this.breadcrumbState.currentPage;
}
